<template>
  <div>
    <nav class="navbar ">
      <div class="navbar-brand">
        <a>
          <router-link to="/">
            <img src="@/assets/ValChrom_logo_2018_color.png" alt="ValChrom: a modern Chromatography Validation tool"
                 width="112" height="28">
          </router-link>
        </a>

        <div class="navbar-burger burger" data-target="navMenuBody">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="navMenuBody" ref="navMenuBody" class="navbar-menu">
        <div class="navbar-end">
          <!-- <div class="navbar-item has-dropdown is-hoverable is-mega">
              <div class="navbar-link">
              Menu
              </div>

              <div id="blogDropdown" class="navbar-dropdown " data-style="width: 18rem;">
                  <div class="container is-fluid">
                      <div class="columns">
                          <div class="column">
                              <h1 class="title is-6 is-mega-menu-title">Analytical Methods</h1>

                              <router-link to="/methods" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      View all Analytical Methods
                                  </div>
                              </router-link>

                              <router-link to="/new-method" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      Create a new Analytical Method
                                  </div>
                              </router-link>
                          </div>

                          <div class="column">
                              <h1 class="title is-6 is-mega-menu-title">Validation Plan Templates</h1>

                              <router-link to="/validation-plan-templates" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      View all Validation Plan Templates
                                  </div>
                              </router-link>
                              <router-link to="/new-validation-plan-template" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      Create a new Validation Plan Templates
                                  </div>
                              </router-link>
                          </div>

                          <div class="column">
                              <h1 class="title is-6 is-mega-menu-title">Experimental Plans</h1>

                              <router-link to="/experimental-plans" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      View all Experimental Plans
                                  </div>
                              </router-link>

                              <router-link to="/new-experimental-plan" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      Create a new Experimental Plans
                                  </div>
                              </router-link>
                          </div>

                          <div class="column">
                              <h1 class="title is-6 is-mega-menu-title">Experimental Datasets</h1>

                              <router-link to="/view-all-experimental-datasets" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      View all Experimental Datasets
                                  </div>
                              </router-link>
                              <router-link to="/new-experimental-dataset" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      Create a new Experimental Dataset
                                  </div>
                              </router-link>
                          </div>
                      </div>
                  </div>

                  <hr class="navbar-divider">
                  <div class="container is-fluid">
                      <div class="columns">
                          <div class="column is-one-quarter">
                              <h1 class="title is-6 is-mega-menu-title">Report Templates</h1>

                              <router-link to="/report-template" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      View all Report Templates
                                  </div>
                              </router-link>
                          </div>

                          <div class="column is-one-quarter">
                              <h1 class="title is-6 is-mega-menu-title">Report</h1>

                              <router-link to="/reports" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      View all Reports
                                  </div>
                              </router-link>
                              <router-link to="/new-report" class="navbar-item">
                                  <div class="navbar-content has-text-link">
                                      Create a new Report
                                  </div>
                              </router-link>
                          </div>
                      </div>
                  </div>
              </div>
          </div>  -->

          <div class="navbar-item has-dropdown is-hoverable" v-if="authenticated">
            <a class="navbar-link  is-active">
              Sections
            </a>
            <div class="navbar-dropdown ">
              <router-link class="navbar-item" to="/dashboard">Dashboard</router-link>
              <hr class="navbar-divider">
              <router-link class="navbar-item" to="/methods">Analytical Methods</router-link>
              <router-link class="navbar-item" to="/validation-plan-templates">Validation Plans</router-link>
              <router-link class="navbar-item" to="/experimental-plans">Experimental Plans</router-link>
              <router-link class="navbar-item" to="/view-all-experimental-datasets">Experimental Datasets</router-link>
              <!-- router-link class="navbar-item" to="/report-templates">Report Templates</router-link -->
              <router-link class="navbar-item" to="/reports">Reports</router-link>
            </div>
          </div>

          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link  is-active">
              Menu
            </a>
            <div class="navbar-dropdown ">
              <router-link class="navbar-item" to="/">Home</router-link>
              <router-link class="navbar-item" to="/about">About</router-link>
              <router-link class="navbar-item" to="/contact">Contact</router-link>
              <router-link class="navbar-item" to="/help">Help</router-link>
              <a class="navbar-item" href="/doe/">Design of Experiments</a>
              <!-- <router-link class="navbar-item" to="/account" v-if="authenticated">Account</router-link> -->
            </div>
          </div>

          <div class="navbar-item has-dropdown is-hoverable" v-if="authenticated">
            <a class="navbar-link  is-active">
              {{ current_user.first_name }} {{ current_user.last_name }}
            </a>
            <div class="navbar-dropdown">
              <a class="navbar-item" @click="logout()">
                Logout
              </a>
              <router-link class="navbar-item" to="/account">Account</router-link>
            </div>
          </div>

          <div class="navbar-item">
            <div class="buttons" v-if="!authenticated">
              <a class="button is-primary" @click="openSignup()" v-if="currentRouteName != 'Landing'"
                 :key="currentRouteName">
                <strong>Sign up</strong>
              </a>
              <router-link class="navbar-item button is-light" to="/login">Log in</router-link>
            </div>
            <!-- <div class="buttons" v-else>
                <a class="button is-light" @click="logout()">
                    Logout
                </a>
            </div> -->
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Navbar',
  props: ['hideNavLogins'],
  data() {
    return {
      currentRouteName: ""
    }
  },
  computed: {
    ...mapGetters([
      'authenticated', 'current_user', 'server_base_url'
    ])
  },
  watch: {
    $route(to, from) {
      this.currentRouteName = this.$router.currentRoute.name;
    }
  },
  mounted: function () {
    this.currentRouteName = this.$router.currentRoute.name;

    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any nav burgers
    if ($navbarBurgers.length > 0) {

      // Add a click event on each of them
      $navbarBurgers.forEach(function ($el) {
        $el.addEventListener('click', function () {

          // Get the target from the "data-target" attribute
          var target = $el.dataset.target;
          var $target = document.getElementById(target);

          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          $el.classList.toggle('is-active');
          $target.classList.toggle('is-active');

        });
      });

      // Hide navbar on mouse leave
      this.$refs.navMenuBody.addEventListener('mouseleave', function () {
        $navbarBurgers.forEach(function ($el) {

          // Get the target from the "data-target" attribute
          var target = $el.dataset.target;
          var $target = document.getElementById(target);

          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          $el.classList.toggle('is-active');
          $target.classList.toggle('is-active');


        });
      })

    }
  },
  methods: {
    openSignup: function () {
      this.$router.push('/signup')
    },
    logout: function () {
      this.$emit("logout")
    }
  },
}
</script>

<style scoped>
.navbar-item.is-mega {
  position: static;
}

.navbar-item.is-mega .is-mega-menu-title {
  margin-bottom: 0;
  padding: .375rem 1rem;
}

.navbar-dropdown, .navbar-item {
  z-index: 10000;
}
</style>